import freelancer_1 from 'assets/images/guides/welcome/freelancer/freelancer-intro-1.png';
import freelancer_2 from 'assets/images/guides/welcome/freelancer/freelancer-intro-2.png';
import freelancer_3 from 'assets/images/guides/welcome/freelancer/freelancer-intro-3.png';
import freelancer_4 from 'assets/images/guides/welcome/freelancer/freelancer-intro-4.png';
import freelancer_5 from 'assets/images/guides/welcome/freelancer/freelancer-intro-5.png';
import freelancer_6 from 'assets/images/guides/welcome/freelancer/freelancer-intro-6.png';
import business_1 from 'assets/images/guides/welcome/business/business-intro-1.png';
import business_2 from 'assets/images/guides/welcome/business/business-intro-2.png';
import business_3 from 'assets/images/guides/welcome/business/business-intro-3.png';
import business_4 from 'assets/images/guides/welcome/business/business-intro-4.png';
import business_5 from 'assets/images/guides/welcome/business/business-intro-5.png';
import business_6 from 'assets/images/guides/welcome/business/business-intro-6.png';

// Quick-start welcome presentation, one deck per partner track. Slides carry an
// image only (no captions); the first slide doubles as the card thumbnail.
const toSlides = (images) => images.map((image) => ({ image }));

export const welcome_freelancer = toSlides([
  freelancer_1,
  freelancer_2,
  freelancer_3,
  freelancer_4,
  freelancer_5,
  freelancer_6
]);

export const welcome_business = toSlides([
  business_1,
  business_2,
  business_3,
  business_4,
  business_5,
  business_6
]);

export const getWelcomeForTrack = (track) =>
  track === 'business' ? welcome_business : welcome_freelancer;
